const Row = ({ children }) => (
  <div className="row">
    {children}
  </div>
);

export default Row;
